import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetProvidersMedicalGuide,
	GetProvidersMedicalGuideModel,
	GetProvidersMedicalGuideParams,
} from 'domain/usecases';

export class RemoteGetProvidersMedicalGuide implements GetProvidersMedicalGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetProvidersMedicalGuideModel>,
	) {}

	async get({
		signal,
		...params
	}: GetProvidersMedicalGuideParams): Promise<GetProvidersMedicalGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
